module.exports = __webpack_public_path__ + "static/media/icon_bar-chart.d7c6575a.svg";